import i18next from 'i18next';

export const schema = () => ({
  'properties': {
    'name': {
      'placeholder': i18next.t('bundleUploadView:placeholderName'),
      'title': i18next.t('bundleUploadView:name'),
      'type': 'string'
    },
    'description': {
      'placeholder': i18next.t('bundleUploadView:placeholderDescription'),
      'title': i18next.t('bundleUploadView:description'),
      'type': 'string'
    },
    'documentTemplateId': {
      'type': 'string'
    },
    'flowTemplateId': {
      'type': 'string'
    }
  },
  'required': [
    'name',
    // 'documentTemplateId',
    'flowTemplateId'
  ],
  'type': 'object'
});

export const uiSchema = {
  'name': {
    'ui:field': 'TextField'
  },
  'description': {
    'ui:field': 'TextField'
  },
  'documentTemplateId': { 'ui:widget': 'hidden' },
  'flowTemplateId': { 'ui:widget': 'hidden' },
  'ui:order': [
    'name',
    'description',
    '*'
  ]
}
;
